import { NumericFormat } from 'react-number-format';
import { Col, Row } from 'antd';

import { DEFAULT_DATE_FORMAT } from '@/contants/common';
import { formatDate } from '@/utils/date';

import Checkbox from '../../../../components/Inputs/Checkbox';
import BatchLabel from '../../../../components/Labels/BatchLabel';
import PrimaryLabel from '../../../../components/Labels/PrimaryLabel';
import Paper from '../../../../components/Paper/Paper';
import TMSFiledCard from '../../../common/components/TMSFiledCard';

const LossAndDamageListCard = ({ data, onSelect, isSelected, handleClaimClick }) => {
  const createdOnLabel = data.createdOn ? formatDate(data.createdOn, DEFAULT_DATE_FORMAT) : 'NA';
  const dateFiledLabel = data.dateFiled ? formatDate(data.dateFiled, DEFAULT_DATE_FORMAT) : 'NA';
  const claimCloseDateLabel = data.claimCloseDate ? formatDate(data.claimCloseDate, DEFAULT_DATE_FORMAT) : 'NA';
  const modifiedOnLabel = data.modifiedOn ? formatDate(data.modifiedOn, DEFAULT_DATE_FORMAT) : 'NA';

  const handleCheckBoxClick = (e) => {
    e.stopPropagation();
    onSelect(data.claimKey, isSelected);
  };

  return (
    <Paper className={`shipment-card border-muted ${isSelected ? 'selected' : ''}`}>
      <div className="p-15" role="button" tabIndex={0} onClick={() => handleClaimClick(data.claimKey)}>
        <Row gutter={15}>
          <Col>
            <Checkbox onClick={handleCheckBoxClick} checked={isSelected} />
          </Col>
          <Col className="flex-1">
            <Row gutter={15}>
              <Col sm={6}>
                <TMSFiledCard containerClass="mb-10" title="Claim Number">
                  <PrimaryLabel>{data.claimNumber}</PrimaryLabel>
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-10" title="Freight Bill / Pro Number">
                  {data.claimProNo}
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-10" title="Invoice Number">
                  {data.invoiceNo}
                </TMSFiledCard>
                <TMSFiledCard title="Transportation Provider">{data.carrierName}</TMSFiledCard>
              </Col>
              <Col sm={6}>
                <TMSFiledCard containerClass="mb-10" title="Consignee">
                  {data.consignee}
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-8" title="Amount Filed">
                  <PrimaryLabel className="text-iconDanger">
                    <NumericFormat
                      thousandsGroupStyle="thousand"
                      displayType="text"
                      value={Number(data.claimTotal).toFixed(2)}
                      thousandSeparator
                    />
                  </PrimaryLabel>
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-8" title="Amount Paid">
                  <PrimaryLabel className="text-success">
                    <NumericFormat
                      thousandsGroupStyle="thousand"
                      displayType="text"
                      value={Number(data.claimPaidAmount).toFixed(2)}
                      thousandSeparator
                    />
                  </PrimaryLabel>
                </TMSFiledCard>
                <TMSFiledCard title="Difference Amount">
                  <PrimaryLabel className="text-header">
                    <NumericFormat
                      thousandsGroupStyle="thousand"
                      displayType="text"
                      value={Number(data.difference).toFixed(2)}
                      thousandSeparator
                    />
                  </PrimaryLabel>
                </TMSFiledCard>
              </Col>
              <Col sm={6}>
                <TMSFiledCard containerClass="mb-10" title="Claim Type">
                  {data.claimType}
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-10" title="Claim Status">
                  <BatchLabel>{data.claimStatus}</BatchLabel>
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-10" title="Filed Date">
                  {dateFiledLabel}
                </TMSFiledCard>
                <TMSFiledCard title="Closed Date">{claimCloseDateLabel}</TMSFiledCard>
              </Col>
              <Col sm={6}>
                <TMSFiledCard containerClass="mb-10" title="Created On">
                  {createdOnLabel}
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-10" title="Created By">
                  {data.createdByUser?.trim() ? data.createdByUser : 'NA'}
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-10" title="Modified On">
                  {modifiedOnLabel}
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-10" title="Modified By">
                  {data.modifiedByUser?.trim() ? data.modifiedByUser : 'NA'}
                </TMSFiledCard>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Paper>
  );
};

export default LossAndDamageListCard;
